
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredbdf"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredbdf"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $2c9b4bdca3b9f06c$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["iSzgC","index.2d28ea15.js","dMsbd","mnet_plus_logo.a82f6a00.png","5mrRH","first_tab_content_en.53a1324b.webp","7Prf4","first_tab_content_ja.56ab0cf7.webp","5uVOc","first_tab_content_ko.ce5523cc.webp","ldwpS","first_tab_content_zh-cn.40d9aa09.webp","a7toJ","first_tab_content_zh-tw.39a78cbc.webp","kMMas","second_tab_content_en.74f6aca9.webp","j4WI7","second_tab_content_ja.183c75dd.webp","l9mcG","second_tab_content_ko.3868c099.webp","lPwWX","second_tab_content_zh-cn.486395a8.webp","4mMIJ","second_tab_content_zh-tw.afe7393f.webp","54wGH","apply_k_en.e3a58edf.webp","eMH8t","apply_k_ja.555fa5fb.webp","60Ii7","apply_k_ko.dca74252.webp","j0HnN","apply_k_zh-cn.c4403091.webp","lxvOA","apply_k_zh-tw.2beee0e3.webp","22g3Y","apply_c_en.a8b4404c.webp","k5kBD","apply_c_ja.07406935.webp","8dQDe","apply_c_ko.7b3793f2.webp","mewZ5","apply_c_zh-cn.6db3b1c3.webp","ePkHi","apply_c_zh-tw.f0a64242.webp","hExD6","tabs_en.4d3be7ee.webp","1gdzD","tabs_ja.7e7d9877.webp","dSuPH","tabs_ko.22207a74.webp","A3uQB","tabs_zh-cn.7f2d5508.webp","k296Y","tabs_zh-tw.c0348324.webp","a0HZz","tabs_en.e3098c8b.webp","8txZ6","tabs_ja.f601bd6f.webp","bPocG","tabs_ko.2f6f9916.webp","b76Bx","tabs_zh-cn.a5689916.webp","hYBGW","tabs_zh-tw.7b56f2a7.webp","gG9f3","faq_closed_btn_non_ja.f93dfbb9.webp","6fhA2","faq_closed_btn_ja.f668c38e.webp","eWCJD","apply_k_faq_closed_btn_en.24dccf27.webp","7VqTx","apply_k_faq_closed_btn_ja.b6e53d5b.webp","eRgYA","apply_k_faq_closed_btn_ko.7c6eb56c.webp","aEvLc","apply_k_faq_closed_btn_zh-cn.7e99c0bf.webp","b9KCa","apply_k_faq_closed_btn_zh-tw.8a6e46ba.webp","89Vtv","apply_c_faq_closed_btn_en.b9f0a47c.webp","aFzZZ","apply_c_faq_closed_btn_ja.f1256abe.webp","1Hkw2","apply_c_faq_closed_btn_ko.135e8141.webp","frwgx","apply_c_faq_closed_btn_zh-cn.3914e2dd.webp","l8Rgs","apply_c_faq_closed_btn_zh-tw.0652da53.webp","igbFg","faq_expanded_en.8d575263.webp","g2AzJ","faq_expanded_ja.eb7c013f.webp","fNzv0","faq_expanded_ko.af68a5da.webp","hgq1H","faq_expanded_zh-cn.22f9e74c.webp","lPUlt","faq_expanded_zh-tw.55f96374.webp","30qRd","apply_k_faq_expanded_en.668f7650.webp","dtPWj","apply_k_faq_expanded_ja.4c5f2d3d.webp","96JYt","apply_k_faq_expanded_ko.744f07f2.webp","g2DHR","apply_k_faq_expanded_zh-cn.9cbf9bca.webp","7QWch","apply_k_faq_expanded_zh-tw.95a1fa67.webp","9BA8A","apply_c_faq_expanded_en.cd868b3b.webp","aXnsu","apply_c_faq_expanded_ja.b22372f8.webp","1dmWV","apply_c_faq_expanded_ko.d48be406.webp","1AvOC","apply_c_faq_expanded_zh-cn.38d8b667.webp","5oEFW","apply_c_faq_expanded_zh-tw.60f6544c.webp","1jFhB","closed-ko.571a6e14.webp","OHzGA","closed-en.ba830d3a.webp","1ff8z","closed-ja.65224cb2.webp","1ID3D","closed-zh-cn.1b728cf5.webp","kbFhm","closed-zh-tw.b7066f21.webp"]'));

function $1b4ea618ab3eb316$export$320c7c562dc23bce() {
    if ($1b4ea618ab3eb316$export$861bd033a4992189()) return "PHASE_3" // hardcoded to PHASE_3 since all the previous conditional statements are commented out
    ;
    else return "CLOSED";
}
function $1b4ea618ab3eb316$export$a6391b78f4f106fe() {
    const applyDeadline = new Date("2025-03-02T15:00:00Z"); // Mark 3 2025 00:00 KST (2차 모집 종료)
    const now = new Date();
    if (now < applyDeadline) return true;
    else return false;
}
function $1b4ea618ab3eb316$export$8bde0eacd3f07e8b() {
    const applyDeadline = new Date("2025-03-23T15:00:00Z"); // Mar 24 2025 00:00 KST (2차 모집 종료)
    const now = new Date();
    if (now < applyDeadline) return true;
    else return false;
}
function $1b4ea618ab3eb316$export$861bd033a4992189() {
    const applyDeadline = new Date("2025-03-23T15:00:00Z"); // Mar 24 2025 00:00 KST (2차 모집 종료)
    const now = new Date();
    if (now < applyDeadline) return true;
    else return false;
}


const $1325fc2d863ad7af$var$metadataConfig = {
    ko: {
        title: `BOYS 2 PLANET | \u{ACF5}\u{C2DD} \u{D648}\u{D398}\u{C774}\u{C9C0} | Mnet`,
        description: `Mnet \u{2018}Boys Planet, Girls Planet, I-LAND \u{C2DC}\u{C98C}1 & \u{C2DC}\u{C98C}2\u{2019} \u{C81C}\u{C791}\u{C9C4}\u{C758} \u{CD08}\u{B300}\u{D615} \u{BCF4}\u{C774} \u{ADF8}\u{B8F9} \u{C624}\u{B514}\u{C158} \u{D504}\u{B85C}\u{C81D}\u{D2B8} <BOYS 2 PLANET>
\u{C138}\u{ACC4} \u{CD5C}\u{CD08} K-POP GLOBAL TWIN PROJECT`,
        keywords: `\u{D50C}\u{B798}\u{B2DB}\u{BE44}, \u{D50C}\u{B798}\u{B2DB} B, \u{D50C}\u{B798}\u{B2DB}B, PLANET B, Mnet \u{D50C}\u{B798}\u{B2DB}B, \u{C5E0}\u{B137} \u{D50C}\u{B798}\u{B2DB}B, Mnet \u{C624}\u{B514}\u{C158}, Mnet \u{C11C}\u{BC14}\u{C774}\u{BC8C}, PLANET B \u{D648}\u{D398}\u{C774}\u{C9C0}, PLANET B \u{B77C}\u{C778}\u{C5C5}, PLANET B \u{CD9C}\u{C5F0}\u{C790}, PLANET B \u{BC29}\u{C1A1}\u{C815}\u{BCF4}, PLANET B \u{D648}\u{D398}\u{C774}\u{C9C0}, PLANET B \u{ACF5}\u{D648}, PLANET B \u{C601}\u{C0C1}, PLANET B \u{D074}\u{B9BD}, PLANET B \u{D22C}\u{D45C}, PLANET B \u{C9C0}\u{C6D0}, \u{D50C}\u{B798}\u{B2DB}B \u{D648}\u{D398}\u{C774}\u{C9C0}, \u{D50C}\u{B798}\u{B2DB}B \u{B77C}\u{C778}\u{C5C5}, \u{D50C}\u{B798}\u{B2DB}B \u{CD9C}\u{C5F0}\u{C790}, \u{D50C}\u{B798}\u{B2DB}B \u{BC29}\u{C1A1}\u{C815}\u{BCF4}, \u{D50C}\u{B798}\u{B2DB}B \u{D648}\u{D398}\u{C774}\u{C9C0}, \u{D50C}\u{B798}\u{B2DB}B \u{ACF5}\u{D648}, \u{D50C}\u{B798}\u{B2DB}B \u{C601}\u{C0C1}, \u{D50C}\u{B798}\u{B2DB}B \u{D074}\u{B9BD}, \u{D50C}\u{B798}\u{B2DB}B \u{D22C}\u{D45C}, \u{D50C}\u{B798}\u{B2DB}B \u{C9C0}\u{C6D0}, \u{BCF4}\u{C774}\u{C988}\u{D50C}\u{B798}\u{B2DB}, \u{AC78}\u{C2A4}\u{D50C}\u{B798}\u{B2DB}, \u{BCF4}\u{C774}\u{C988}\u{D50C}\u{B798}\u{B2DB}2, \u{C544}\u{C774}\u{B79C}\u{B4DC}, \u{C544}\u{C774}\u{B79C}\u{B4DC}2, BOYS PLANET, BOYS PLANET2, ILAND, I-LAND, I-LAND2, Girls Planet, boys 2 planet`,
        ogTitle: "BOYS 2 PLANET | \uACF5\uC2DD \uD648\uD398\uC774\uC9C0 | Mnet",
        ogDescription: `Mnet \u{2018}Boys Planet, Girls Planet, I-LAND \u{C2DC}\u{C98C}1 & \u{C2DC}\u{C98C}2\u{2019} \u{C81C}\u{C791}\u{C9C4}\u{C758} \u{CD08}\u{B300}\u{D615} \u{BCF4}\u{C774} \u{ADF8}\u{B8F9} \u{C624}\u{B514}\u{C158} \u{D504}\u{B85C}\u{C81D}\u{D2B8} <BOYS 2 PLANET>
\u{C138}\u{ACC4} \u{CD5C}\u{CD08} K-POP GLOBAL TWIN PROJECT`
    },
    default: {
        title: "BOYS 2 PLANET | Official Website | Mnet",
        description: `From the producers of Mnet's \u{2018}Boys Planet, Girls Planet, and I-LAND Season 1 & Season 2\u{2019}, comes a mega boy group audition project <BOYS 2 PLANET>
The World's First GLOBAL K-POP TWIN PROJECT`,
        keywords: `PLANET B, Mnet PLANET B, Mnet audition, Mnet survival, PLANET B lineup, PLANET B cast, PLANET B broadcast information, PLANET B homepage, PLANET B video, PLANET B clip, PLANET B vote, BOYS PLANET, BOYS PLANET2, ILAND, I-LAND, I-LAND2, Girls Planet, boys 2 planet`,
        ogTitle: `BOYS 2 PLANET | Official Website | Mnet`,
        ogDescription: `From the producers of Mnet's \u{2018}Boys Planet, Girls Planet, and I-LAND Season 1 & Season 2\u{2019}, comes a mega boy group audition project <BOYS 2 PLANET>
The World's First GLOBAL K-POP TWIN PROJECT`
    }
};
const $1325fc2d863ad7af$var$CURRENT_PHASE = (0, $1b4ea618ab3eb316$export$320c7c562dc23bce)();
class $1325fc2d863ad7af$export$de90c65777477aa1 {
    constructor(){
        this.params = new URLSearchParams(window.location.search);
        this.validateAndUpdateParams();
        // Initial metadata update
        this.updateMetadata(this.getParam("locale"));
    }
    validateAndUpdateParams() {
        const validLocales = [
            "en",
            "ja",
            "ko",
            "zh-CN",
            "zh-TW"
        ];
        let locale = this.params.get("locale");
        if (!locale || !validLocales.includes(locale)) {
            locale = "en";
            this.params.set("locale", locale);
        }
        // Handle applyLang for other phases
        const applyLang = this.params.get("applyLang");
        if (applyLang) {
            if (applyLang === "cn") {
                if (!(0, $1b4ea618ab3eb316$export$a6391b78f4f106fe)()) this.params.delete("applyLang");
            }
            if (applyLang === "ko") {
                if (!(0, $1b4ea618ab3eb316$export$8bde0eacd3f07e8b)()) this.params.delete("applyLang");
            }
            if (![
                "ko",
                "cn"
            ].includes(applyLang)) this.params.set("applyLang", "ko");
        }
        // Handle tab parameter
        const tab = this.params.get("tab");
        const validTabs = [
            "first",
            "second"
        ];
        if (!this.params.get("applyLang")) {
            if (!tab || !validTabs.includes(tab)) this.params.set("tab", "first");
        }
        this.updateURL();
    }
    updateURL() {
        const newURL = `${window.location.pathname}?${this.params.toString()}`;
        window.history.replaceState({}, "", newURL);
    }
    getParam(key) {
        return this.params.get(key);
    }
    setParam(key, value) {
        if (value === null) this.params.delete(key);
        else this.params.set(key, value);
        this.updateURL();
        // Update metadata when locale changes
        if (key === "locale") this.updateMetadata(value);
    }
    updateMetadata(locale) {
        const metadata = locale === "ko" ? $1325fc2d863ad7af$var$metadataConfig.ko : $1325fc2d863ad7af$var$metadataConfig.default;
        // Update meta description
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) metaDescription.setAttribute("content", metadata.description);
        else console.error("Meta tag for description not found");
        // Update Open Graph tags
        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) ogTitle.setAttribute("content", metadata.ogTitle);
        else console.error("Meta tag for og:title not found");
        const ogDescription = document.querySelector('meta[property="og:description"]');
        if (ogDescription) ogDescription.setAttribute("content", metadata.ogDescription);
        else console.error("Meta tag for og:description not found");
        // Update keywords
        const keywords = document.querySelector('meta[name="keywords"]');
        if (keywords) keywords.setAttribute("content", metadata.keywords);
        else console.error("Meta tag for keywords not found");
        // Update title tag
        const title = document.querySelector("title");
        if (title) title.textContent = metadata.title;
        else console.error("Title tag not found");
    }
}


var $082908ab5b5b551a$exports = {};
$082908ab5b5b551a$exports = new URL("mnet_plus_logo.a82f6a00.png", import.meta.url).toString();


var $de8cf24915a43d5c$exports = {};
$de8cf24915a43d5c$exports = new URL("first_tab_content_en.53a1324b.webp", import.meta.url).toString();


var $7f137dc04b45f79a$exports = {};
$7f137dc04b45f79a$exports = new URL("first_tab_content_ja.56ab0cf7.webp", import.meta.url).toString();


var $7c65236f426e13b9$exports = {};
$7c65236f426e13b9$exports = new URL("first_tab_content_ko.ce5523cc.webp", import.meta.url).toString();


var $d02f44ce3fda1b08$exports = {};
$d02f44ce3fda1b08$exports = new URL("first_tab_content_zh-cn.40d9aa09.webp", import.meta.url).toString();


var $d968b5c515752fbc$exports = {};
$d968b5c515752fbc$exports = new URL("first_tab_content_zh-tw.39a78cbc.webp", import.meta.url).toString();


var $1bb47105e7ccfcf4$exports = {};
$1bb47105e7ccfcf4$exports = new URL("second_tab_content_en.74f6aca9.webp", import.meta.url).toString();


var $3467e3bb4fdc1b5e$exports = {};
$3467e3bb4fdc1b5e$exports = new URL("second_tab_content_ja.183c75dd.webp", import.meta.url).toString();


var $1ee8c5d8e873b043$exports = {};
$1ee8c5d8e873b043$exports = new URL("second_tab_content_ko.3868c099.webp", import.meta.url).toString();


var $653062398142ac20$exports = {};
$653062398142ac20$exports = new URL("second_tab_content_zh-cn.486395a8.webp", import.meta.url).toString();


var $5bb943ee3b2cf593$exports = {};
$5bb943ee3b2cf593$exports = new URL("second_tab_content_zh-tw.afe7393f.webp", import.meta.url).toString();


var $b5635398c204897f$exports = {};
$b5635398c204897f$exports = new URL("apply_k_en.e3a58edf.webp", import.meta.url).toString();


var $b1bb9a8112961900$exports = {};
$b1bb9a8112961900$exports = new URL("apply_k_ja.555fa5fb.webp", import.meta.url).toString();


var $ac551460ff3ea27e$exports = {};
$ac551460ff3ea27e$exports = new URL("apply_k_ko.dca74252.webp", import.meta.url).toString();


var $deb6346fab3b0fd0$exports = {};
$deb6346fab3b0fd0$exports = new URL("apply_k_zh-cn.c4403091.webp", import.meta.url).toString();


var $11ea4b2b957541b0$exports = {};
$11ea4b2b957541b0$exports = new URL("apply_k_zh-tw.2beee0e3.webp", import.meta.url).toString();


var $c6e8e37630ba5305$exports = {};
$c6e8e37630ba5305$exports = new URL("apply_c_en.a8b4404c.webp", import.meta.url).toString();


var $1a343fa36d9c67e6$exports = {};
$1a343fa36d9c67e6$exports = new URL("apply_c_ja.07406935.webp", import.meta.url).toString();


var $ccffefe54f018d8a$exports = {};
$ccffefe54f018d8a$exports = new URL("apply_c_ko.7b3793f2.webp", import.meta.url).toString();


var $fee38bd8c3acae82$exports = {};
$fee38bd8c3acae82$exports = new URL("apply_c_zh-cn.6db3b1c3.webp", import.meta.url).toString();


var $0168b2d5dc74685c$exports = {};
$0168b2d5dc74685c$exports = new URL("apply_c_zh-tw.f0a64242.webp", import.meta.url).toString();


var $f9b35c81e3b50c42$exports = {};
$f9b35c81e3b50c42$exports = new URL("tabs_en.4d3be7ee.webp", import.meta.url).toString();


var $9e6d28dead8573ff$exports = {};
$9e6d28dead8573ff$exports = new URL("tabs_ja.7e7d9877.webp", import.meta.url).toString();


var $ea94034c54fba191$exports = {};
$ea94034c54fba191$exports = new URL("tabs_ko.22207a74.webp", import.meta.url).toString();


var $3c5fea3b95b1866a$exports = {};
$3c5fea3b95b1866a$exports = new URL("tabs_zh-cn.7f2d5508.webp", import.meta.url).toString();


var $5db99a5a7c9efe05$exports = {};
$5db99a5a7c9efe05$exports = new URL("tabs_zh-tw.c0348324.webp", import.meta.url).toString();


var $b7dd2f4ac83656d1$exports = {};
$b7dd2f4ac83656d1$exports = new URL("tabs_en.e3098c8b.webp", import.meta.url).toString();


var $649fccbda8c9decc$exports = {};
$649fccbda8c9decc$exports = new URL("tabs_ja.f601bd6f.webp", import.meta.url).toString();


var $b5fa337c6ee967e2$exports = {};
$b5fa337c6ee967e2$exports = new URL("tabs_ko.2f6f9916.webp", import.meta.url).toString();


var $48f619d63b475867$exports = {};
$48f619d63b475867$exports = new URL("tabs_zh-cn.a5689916.webp", import.meta.url).toString();


var $788101e4675852b0$exports = {};
$788101e4675852b0$exports = new URL("tabs_zh-tw.7b56f2a7.webp", import.meta.url).toString();


var $c343fe4067e7248c$exports = {};
$c343fe4067e7248c$exports = new URL("faq_closed_btn_non_ja.f93dfbb9.webp", import.meta.url).toString();


var $1da7de39c5ed5ed3$exports = {};
$1da7de39c5ed5ed3$exports = new URL("faq_closed_btn_ja.f668c38e.webp", import.meta.url).toString();


var $fab1fb8b95497642$exports = {};
$fab1fb8b95497642$exports = new URL("apply_k_faq_closed_btn_en.24dccf27.webp", import.meta.url).toString();


var $bbd4ff4f7bab8270$exports = {};
$bbd4ff4f7bab8270$exports = new URL("apply_k_faq_closed_btn_ja.b6e53d5b.webp", import.meta.url).toString();


var $b28dac5372d4ed72$exports = {};
$b28dac5372d4ed72$exports = new URL("apply_k_faq_closed_btn_ko.7c6eb56c.webp", import.meta.url).toString();


var $c40eac5de605692e$exports = {};
$c40eac5de605692e$exports = new URL("apply_k_faq_closed_btn_zh-cn.7e99c0bf.webp", import.meta.url).toString();


var $f587db6997cb0eff$exports = {};
$f587db6997cb0eff$exports = new URL("apply_k_faq_closed_btn_zh-tw.8a6e46ba.webp", import.meta.url).toString();


var $a4431d04b06b1779$exports = {};
$a4431d04b06b1779$exports = new URL("apply_c_faq_closed_btn_en.b9f0a47c.webp", import.meta.url).toString();


var $e4ba96f1d69e24b4$exports = {};
$e4ba96f1d69e24b4$exports = new URL("apply_c_faq_closed_btn_ja.f1256abe.webp", import.meta.url).toString();


var $fbef5ec8789330ae$exports = {};
$fbef5ec8789330ae$exports = new URL("apply_c_faq_closed_btn_ko.135e8141.webp", import.meta.url).toString();


var $205692df4c0e5251$exports = {};
$205692df4c0e5251$exports = new URL("apply_c_faq_closed_btn_zh-cn.3914e2dd.webp", import.meta.url).toString();


var $dee8d6566e1e8420$exports = {};
$dee8d6566e1e8420$exports = new URL("apply_c_faq_closed_btn_zh-tw.0652da53.webp", import.meta.url).toString();


var $5db5b25278bb1af8$exports = {};
$5db5b25278bb1af8$exports = new URL("faq_expanded_en.8d575263.webp", import.meta.url).toString();


var $06f4d6416649ec68$exports = {};
$06f4d6416649ec68$exports = new URL("faq_expanded_ja.eb7c013f.webp", import.meta.url).toString();


var $2b2f661b826b77a7$exports = {};
$2b2f661b826b77a7$exports = new URL("faq_expanded_ko.af68a5da.webp", import.meta.url).toString();


var $1d49d81b26557d5d$exports = {};
$1d49d81b26557d5d$exports = new URL("faq_expanded_zh-cn.22f9e74c.webp", import.meta.url).toString();


var $9fda5ed6682cd2cf$exports = {};
$9fda5ed6682cd2cf$exports = new URL("faq_expanded_zh-tw.55f96374.webp", import.meta.url).toString();


var $22217115c16d9d4f$exports = {};
$22217115c16d9d4f$exports = new URL("apply_k_faq_expanded_en.668f7650.webp", import.meta.url).toString();


var $9e0549abc6299365$exports = {};
$9e0549abc6299365$exports = new URL("apply_k_faq_expanded_ja.4c5f2d3d.webp", import.meta.url).toString();


var $90b8c412be8325ef$exports = {};
$90b8c412be8325ef$exports = new URL("apply_k_faq_expanded_ko.744f07f2.webp", import.meta.url).toString();


var $2674c3def734d181$exports = {};
$2674c3def734d181$exports = new URL("apply_k_faq_expanded_zh-cn.9cbf9bca.webp", import.meta.url).toString();


var $28cc1176ed87d644$exports = {};
$28cc1176ed87d644$exports = new URL("apply_k_faq_expanded_zh-tw.95a1fa67.webp", import.meta.url).toString();


var $1ed81867b22dcb9b$exports = {};
$1ed81867b22dcb9b$exports = new URL("apply_c_faq_expanded_en.cd868b3b.webp", import.meta.url).toString();


var $8d8c8b0c4cb9b6ec$exports = {};
$8d8c8b0c4cb9b6ec$exports = new URL("apply_c_faq_expanded_ja.b22372f8.webp", import.meta.url).toString();


var $d9706b67ba3192ab$exports = {};
$d9706b67ba3192ab$exports = new URL("apply_c_faq_expanded_ko.d48be406.webp", import.meta.url).toString();


var $3549251ed2ae0ef7$exports = {};
$3549251ed2ae0ef7$exports = new URL("apply_c_faq_expanded_zh-cn.38d8b667.webp", import.meta.url).toString();


var $efdc76802ab34a46$exports = {};
$efdc76802ab34a46$exports = new URL("apply_c_faq_expanded_zh-tw.60f6544c.webp", import.meta.url).toString();


const $a8820ced89723836$export$d39c6d1fbf5f64b6 = {
    contentImages: {
        first: {
            en: (0, (/*@__PURE__*/$parcel$interopDefault($de8cf24915a43d5c$exports))),
            ja: (0, (/*@__PURE__*/$parcel$interopDefault($7f137dc04b45f79a$exports))),
            ko: (0, (/*@__PURE__*/$parcel$interopDefault($7c65236f426e13b9$exports))),
            "zh-CN": (0, (/*@__PURE__*/$parcel$interopDefault($d02f44ce3fda1b08$exports))),
            "zh-TW": (0, (/*@__PURE__*/$parcel$interopDefault($d968b5c515752fbc$exports)))
        },
        second: {
            en: (0, (/*@__PURE__*/$parcel$interopDefault($1bb47105e7ccfcf4$exports))),
            ja: (0, (/*@__PURE__*/$parcel$interopDefault($3467e3bb4fdc1b5e$exports))),
            ko: (0, (/*@__PURE__*/$parcel$interopDefault($1ee8c5d8e873b043$exports))),
            "zh-CN": (0, (/*@__PURE__*/$parcel$interopDefault($653062398142ac20$exports))),
            "zh-TW": (0, (/*@__PURE__*/$parcel$interopDefault($5bb943ee3b2cf593$exports)))
        }
    },
    tabBarImages: {
        first: {
            en: (0, (/*@__PURE__*/$parcel$interopDefault($f9b35c81e3b50c42$exports))),
            ja: (0, (/*@__PURE__*/$parcel$interopDefault($9e6d28dead8573ff$exports))),
            ko: (0, (/*@__PURE__*/$parcel$interopDefault($ea94034c54fba191$exports))),
            "zh-CN": (0, (/*@__PURE__*/$parcel$interopDefault($3c5fea3b95b1866a$exports))),
            "zh-TW": (0, (/*@__PURE__*/$parcel$interopDefault($5db99a5a7c9efe05$exports)))
        },
        second: {
            en: (0, (/*@__PURE__*/$parcel$interopDefault($b7dd2f4ac83656d1$exports))),
            ja: (0, (/*@__PURE__*/$parcel$interopDefault($649fccbda8c9decc$exports))),
            ko: (0, (/*@__PURE__*/$parcel$interopDefault($b5fa337c6ee967e2$exports))),
            "zh-CN": (0, (/*@__PURE__*/$parcel$interopDefault($48f619d63b475867$exports))),
            "zh-TW": (0, (/*@__PURE__*/$parcel$interopDefault($788101e4675852b0$exports)))
        }
    },
    applyContentImages: {
        ko: {
            en: (0, (/*@__PURE__*/$parcel$interopDefault($b5635398c204897f$exports))),
            ja: (0, (/*@__PURE__*/$parcel$interopDefault($b1bb9a8112961900$exports))),
            ko: (0, (/*@__PURE__*/$parcel$interopDefault($ac551460ff3ea27e$exports))),
            "zh-CN": (0, (/*@__PURE__*/$parcel$interopDefault($deb6346fab3b0fd0$exports))),
            "zh-TW": (0, (/*@__PURE__*/$parcel$interopDefault($11ea4b2b957541b0$exports)))
        },
        cn: {
            en: (0, (/*@__PURE__*/$parcel$interopDefault($c6e8e37630ba5305$exports))),
            ja: (0, (/*@__PURE__*/$parcel$interopDefault($1a343fa36d9c67e6$exports))),
            ko: (0, (/*@__PURE__*/$parcel$interopDefault($ccffefe54f018d8a$exports))),
            "zh-CN": (0, (/*@__PURE__*/$parcel$interopDefault($fee38bd8c3acae82$exports))),
            "zh-TW": (0, (/*@__PURE__*/$parcel$interopDefault($0168b2d5dc74685c$exports)))
        }
    },
    faqImages: {
        closed: {
            secondTab: {
                en: (0, (/*@__PURE__*/$parcel$interopDefault($c343fe4067e7248c$exports))),
                ja: (0, (/*@__PURE__*/$parcel$interopDefault($1da7de39c5ed5ed3$exports))),
                ko: (0, (/*@__PURE__*/$parcel$interopDefault($c343fe4067e7248c$exports))),
                "zh-CN": (0, (/*@__PURE__*/$parcel$interopDefault($c343fe4067e7248c$exports))),
                "zh-TW": (0, (/*@__PURE__*/$parcel$interopDefault($c343fe4067e7248c$exports)))
            },
            apply: {
                ko: {
                    en: (0, (/*@__PURE__*/$parcel$interopDefault($fab1fb8b95497642$exports))),
                    ja: (0, (/*@__PURE__*/$parcel$interopDefault($bbd4ff4f7bab8270$exports))),
                    ko: (0, (/*@__PURE__*/$parcel$interopDefault($b28dac5372d4ed72$exports))),
                    "zh-CN": (0, (/*@__PURE__*/$parcel$interopDefault($c40eac5de605692e$exports))),
                    "zh-TW": (0, (/*@__PURE__*/$parcel$interopDefault($f587db6997cb0eff$exports)))
                },
                cn: {
                    en: (0, (/*@__PURE__*/$parcel$interopDefault($a4431d04b06b1779$exports))),
                    ja: (0, (/*@__PURE__*/$parcel$interopDefault($e4ba96f1d69e24b4$exports))),
                    ko: (0, (/*@__PURE__*/$parcel$interopDefault($fbef5ec8789330ae$exports))),
                    "zh-CN": (0, (/*@__PURE__*/$parcel$interopDefault($205692df4c0e5251$exports))),
                    "zh-TW": (0, (/*@__PURE__*/$parcel$interopDefault($dee8d6566e1e8420$exports)))
                }
            }
        },
        expanded: {
            secondTab: {
                en: (0, (/*@__PURE__*/$parcel$interopDefault($5db5b25278bb1af8$exports))),
                ja: (0, (/*@__PURE__*/$parcel$interopDefault($06f4d6416649ec68$exports))),
                ko: (0, (/*@__PURE__*/$parcel$interopDefault($2b2f661b826b77a7$exports))),
                "zh-CN": (0, (/*@__PURE__*/$parcel$interopDefault($1d49d81b26557d5d$exports))),
                "zh-TW": (0, (/*@__PURE__*/$parcel$interopDefault($9fda5ed6682cd2cf$exports)))
            },
            apply: {
                ko: {
                    en: (0, (/*@__PURE__*/$parcel$interopDefault($22217115c16d9d4f$exports))),
                    ja: (0, (/*@__PURE__*/$parcel$interopDefault($9e0549abc6299365$exports))),
                    ko: (0, (/*@__PURE__*/$parcel$interopDefault($90b8c412be8325ef$exports))),
                    "zh-CN": (0, (/*@__PURE__*/$parcel$interopDefault($2674c3def734d181$exports))),
                    "zh-TW": (0, (/*@__PURE__*/$parcel$interopDefault($28cc1176ed87d644$exports)))
                },
                cn: {
                    en: (0, (/*@__PURE__*/$parcel$interopDefault($1ed81867b22dcb9b$exports))),
                    ja: (0, (/*@__PURE__*/$parcel$interopDefault($8d8c8b0c4cb9b6ec$exports))),
                    ko: (0, (/*@__PURE__*/$parcel$interopDefault($d9706b67ba3192ab$exports))),
                    "zh-CN": (0, (/*@__PURE__*/$parcel$interopDefault($3549251ed2ae0ef7$exports))),
                    "zh-TW": (0, (/*@__PURE__*/$parcel$interopDefault($efdc76802ab34a46$exports)))
                }
            }
        }
    }
};


var $c93a0c72b7b228c8$exports = {};
$c93a0c72b7b228c8$exports = new URL("closed-ko.571a6e14.webp", import.meta.url).toString();


var $399b63c918666689$exports = {};
$399b63c918666689$exports = new URL("closed-en.ba830d3a.webp", import.meta.url).toString();


var $48dea50fda61580c$exports = {};
$48dea50fda61580c$exports = new URL("closed-ja.65224cb2.webp", import.meta.url).toString();


var $9cce9459879d9f6b$exports = {};
$9cce9459879d9f6b$exports = new URL("closed-zh-cn.1b728cf5.webp", import.meta.url).toString();


var $fb62140d61880570$exports = {};
$fb62140d61880570$exports = new URL("closed-zh-tw.b7066f21.webp", import.meta.url).toString();


const $ac58a611ee7c1b70$export$a98c10860b51fe76 = {
    contentImages: {
        closed: {
            en: (0, (/*@__PURE__*/$parcel$interopDefault($399b63c918666689$exports))),
            ja: (0, (/*@__PURE__*/$parcel$interopDefault($48dea50fda61580c$exports))),
            ko: (0, (/*@__PURE__*/$parcel$interopDefault($c93a0c72b7b228c8$exports))),
            "zh-CN": (0, (/*@__PURE__*/$parcel$interopDefault($9cce9459879d9f6b$exports))),
            "zh-TW": (0, (/*@__PURE__*/$parcel$interopDefault($fb62140d61880570$exports)))
        }
    }
};
function $ac58a611ee7c1b70$export$8c49e528e4844b39(locale) {
    return $ac58a611ee7c1b70$export$a98c10860b51fe76.contentImages.closed[locale] || $ac58a611ee7c1b70$export$a98c10860b51fe76.contentImages.closed.en;
}
function $ac58a611ee7c1b70$export$7aff5feae6bc0c19() {
    const promises = [];
    Object.values($ac58a611ee7c1b70$export$a98c10860b51fe76.contentImages.closed).forEach((src)=>{
        const img = new Image();
        const promise = new Promise((resolve)=>{
            img.onload = resolve;
            img.onerror = resolve; // Still resolve even on error to avoid blocking
            img.src = src;
        });
        promises.push(promise);
    });
    return Promise.all(promises);
}



const $b3698d22069af6cf$var$videoConfig = {
    chinese: {
        first: "//player.bilibili.com/player.html?isOutside=true&bvid=BV1AnUDYGEWx&&p=1",
        second: "//player.bilibili.com/player.html?isOutside=true&bvid=BV1S2FReFE2q&&p=1"
    },
    default: {
        first: "https://www.youtube.com/embed/KRaQRiKJUc0",
        second: "https://www.youtube.com/embed/WgKgBpfZkcE"
    }
};
const $b3698d22069af6cf$var$PHASE_IMAGES = {
    PHASE_3: (0, $a8820ced89723836$export$d39c6d1fbf5f64b6),
    CLOSED: (0, $ac58a611ee7c1b70$export$a98c10860b51fe76)
};
const $b3698d22069af6cf$var$CURRENT_PHASE = (0, $1b4ea618ab3eb316$export$320c7c562dc23bce)();
const $b3698d22069af6cf$var$styleConfig = {
    PHASE_3: {
        firstTab: {
            youtube: {
                en: {
                    top: "16.2%",
                    left: "50%",
                    width: "85.65%",
                    height: "9.4%"
                },
                ja: {
                    top: "16.7%",
                    left: "50%",
                    width: "85.65%",
                    height: "9.8%"
                },
                ko: {
                    top: "16.5%",
                    left: "50%",
                    width: "85.65%",
                    height: "9.7%"
                },
                "zh-CN": {
                    top: "17.05%",
                    left: "50%",
                    width: "85.72%",
                    height: "10%"
                },
                "zh-TW": {
                    top: "16.9%",
                    left: "50%",
                    width: "85.8%",
                    height: "10%"
                }
            },
            youtube2: {
                en: {
                    top: "44.4%",
                    left: "50%",
                    width: "85.65%",
                    height: "9.4%"
                },
                ja: {
                    top: "43.8%",
                    left: "50%",
                    width: "85.65%",
                    height: "9.8%"
                },
                ko: {
                    top: "43%",
                    left: "50%",
                    width: "85.65%",
                    height: "9.7%"
                },
                "zh-CN": {
                    top: "44.05%",
                    left: "50%",
                    width: "85.72%",
                    height: "10%"
                },
                "zh-TW": {
                    top: "43.7%",
                    left: "50%",
                    width: "85.8%",
                    height: "10%"
                }
            },
            nextButton: {
                en: {
                    right: "7%",
                    top: "62.5%",
                    width: "86%",
                    height: "3.6%"
                },
                ko: {
                    right: "7%",
                    top: "61.7%",
                    width: "86%",
                    height: "3.5%"
                },
                ja: {
                    right: "7%",
                    top: "63.2%",
                    width: "86%",
                    height: "3.6%"
                },
                "zh-CN": {
                    right: "7%",
                    top: "62.4%",
                    width: "86%",
                    height: "3.6%"
                },
                "zh-TW": {
                    right: "7%",
                    top: "62.7%",
                    width: "86%",
                    height: "3.6%"
                }
            }
        },
        secondTab: {
            applyButtons: {
                en: {
                    korean: {
                        top: "77%",
                        left: "10.3%",
                        width: "35%",
                        height: "13.4%"
                    },
                    chinese: {
                        top: "77%",
                        right: "10.3%",
                        width: "35%",
                        height: "13.4%"
                    }
                },
                ja: {
                    korean: {
                        top: "75.6%",
                        left: "10.3%",
                        width: "35%",
                        height: "14.2%"
                    },
                    chinese: {
                        top: "75.6%",
                        right: "10.3%",
                        width: "35%",
                        height: "14.2%"
                    }
                },
                ko: {
                    korean: {
                        top: "77.0%",
                        left: "10.5%",
                        width: "35%",
                        height: "13.7%"
                    },
                    chinese: {
                        top: "77.0%",
                        right: "10.5%",
                        width: "35%",
                        height: "13.7%"
                    }
                },
                "zh-CN": {
                    korean: {
                        top: "76.8%",
                        left: "10.5%",
                        width: "35%",
                        height: "15%"
                    },
                    chinese: {
                        top: "76.8%",
                        right: "10.5%",
                        width: "35%",
                        height: "15%"
                    }
                },
                "zh-TW": {
                    korean: {
                        top: "75.3%",
                        left: "10.7%",
                        width: "35%",
                        height: "14.5%"
                    },
                    chinese: {
                        top: "75.3%",
                        right: "10.7%",
                        width: "35%",
                        height: "14.5%"
                    }
                }
            }
        },
        apply: {
            links: {
                en: {
                    link1: {
                        top: "32.4%",
                        left: "11%",
                        width: "37.5%",
                        height: "2.74%",
                        borderRadius: "30px"
                    },
                    link2: {
                        top: "32.4%",
                        right: "11%",
                        width: "37.5%",
                        height: "2.74%",
                        borderRadius: "30px"
                    },
                    link3: {
                        top: "36%",
                        left: "11%",
                        width: "37.5%",
                        height: "2.74%",
                        borderRadius: "30px"
                    },
                    link4: {
                        top: "36%",
                        right: "11%",
                        width: "37.5%",
                        height: "2.74%",
                        borderRadius: "30px"
                    }
                },
                ko: {
                    link1: {
                        top: "30.73%",
                        left: "11%",
                        width: "37.5%",
                        height: "2.74%",
                        borderRadius: "30px"
                    },
                    link2: {
                        top: "30.73%",
                        right: "11%",
                        width: "37.5%",
                        height: "2.74%",
                        borderRadius: "30px"
                    },
                    link3: {
                        top: "34.35%",
                        left: "11%",
                        width: "37.5%",
                        height: "2.74%",
                        borderRadius: "30px"
                    },
                    link4: {
                        top: "34.35%",
                        right: "11%",
                        width: "37.5%",
                        height: "2.74%",
                        borderRadius: "30px"
                    }
                },
                ja: {
                    link1: {
                        top: "30.4%",
                        left: "11%",
                        width: "37.5%",
                        height: "2.74%",
                        borderRadius: "30px"
                    },
                    link2: {
                        top: "30.4%",
                        right: "11%",
                        width: "37.5%",
                        height: "2.74%",
                        borderRadius: "30px"
                    },
                    link3: {
                        top: "34%",
                        left: "11%",
                        width: "37.5%",
                        height: "2.74%",
                        borderRadius: "30px"
                    },
                    link4: {
                        top: "34%",
                        right: "11%",
                        width: "37.5%",
                        height: "2.74%",
                        borderRadius: "30px"
                    }
                },
                "zh-CN": {
                    link1: {
                        top: "31.8%",
                        left: "11%",
                        width: "37.5%",
                        height: "2.78%",
                        borderRadius: "30px"
                    },
                    link2: {
                        top: "31.8%",
                        right: "11%",
                        width: "37.5%",
                        height: "2.78%",
                        borderRadius: "30px"
                    },
                    link3: {
                        top: "35.65%",
                        left: "11%",
                        width: "37.5%",
                        height: "2.78%",
                        borderRadius: "30px"
                    },
                    link4: {
                        top: "35.65%",
                        right: "11%",
                        width: "37.5%",
                        height: "2.78%",
                        borderRadius: "30px"
                    }
                },
                "zh-TW": {
                    link1: {
                        top: "31.5%",
                        left: "11%",
                        width: "37.5%",
                        height: "2.78%",
                        borderRadius: "30px"
                    },
                    link2: {
                        top: "31.5%",
                        right: "11%",
                        width: "37.5%",
                        height: "2.78%",
                        borderRadius: "30px"
                    },
                    link3: {
                        top: "35.2%",
                        left: "11%",
                        width: "37.5%",
                        height: "2.78%",
                        borderRadius: "30px"
                    },
                    link4: {
                        top: "35.2%",
                        right: "11%",
                        width: "37.5%",
                        height: "2.78%",
                        borderRadius: "30px"
                    }
                }
            }
        }
    },
    CLOSED: {
        youtube: {
            en: {
                top: "22%",
                left: "50%",
                width: "86%",
                height: "18%"
            },
            ja: {
                top: "23%",
                left: "50%",
                width: "86%",
                height: "18.5%"
            },
            ko: {
                top: "23%",
                left: "50%",
                width: "86%",
                height: "18.5%"
            },
            "zh-CN": {
                top: "23.5%",
                left: "50%",
                width: "86%",
                height: "19.2%"
            },
            "zh-TW": {
                top: "23.5%",
                left: "50%",
                width: "86%",
                height: "19.2%"
            }
        }
    }
};
// Create image maps
const $b3698d22069af6cf$var$contentImages = $b3698d22069af6cf$var$PHASE_IMAGES[$b3698d22069af6cf$var$CURRENT_PHASE].contentImages;
const $b3698d22069af6cf$var$tabBarImages = $b3698d22069af6cf$var$PHASE_IMAGES[$b3698d22069af6cf$var$CURRENT_PHASE].tabBarImages;
const $b3698d22069af6cf$var$applyContentImages = $b3698d22069af6cf$var$PHASE_IMAGES[$b3698d22069af6cf$var$CURRENT_PHASE].applyContentImages;
const $b3698d22069af6cf$var$faqImages = $b3698d22069af6cf$var$PHASE_IMAGES[$b3698d22069af6cf$var$CURRENT_PHASE].faqImages;
const $b3698d22069af6cf$var$externalLinksConfig = {
    ko: {
        link1: "https://form.typeform.com/to/CyO2hYFS",
        link2: "https://form.typeform.com/to/jwge4Z2w",
        link3: "https://form.typeform.com/to/XCHsjWlj",
        link4: "https://form.typeform.com/to/Biz1bvqk"
    },
    cn: {
        link1: "https://form.typeform.com/to/IoJKlPGD",
        link2: "https://form.typeform.com/to/Zk88jRBc",
        link3: "https://form.typeform.com/to/t0kx96ZU",
        link4: "https://form.typeform.com/to/N6Yl5BvD"
    }
};
class $b3698d22069af6cf$export$3c34ec388832a30 {
    constructor(urlManager){
        this.urlManager = urlManager;
        this.previousState = null;
        this.preloadedImages = new Map();
        this.faqStates = {
            secondTab: false,
            apply: false
        };
        this.preloadedVideos = {
            // Add this
            chinese: null,
            default: null
        };
        this.preloadAllImages();
        this.preloadVideos();
        this.initializeContent();
        this.setupEventListeners();
    }
    preloadAllImages() {
        if ($b3698d22069af6cf$var$CURRENT_PHASE === "CLOSED") {
            // Only preload closed images when in CLOSED phase
            if ((0, $ac58a611ee7c1b70$export$a98c10860b51fe76) && (0, $ac58a611ee7c1b70$export$a98c10860b51fe76).contentImages && (0, $ac58a611ee7c1b70$export$a98c10860b51fe76).contentImages.closed) Object.entries((0, $ac58a611ee7c1b70$export$a98c10860b51fe76).contentImages.closed).forEach(([locale, imageSrc])=>{
                this.preloadImage(`closed_content_${locale}`, imageSrc);
            });
            return; // Exit early - no need to load other images
        }
        // Base images (common across all phases)
        [
            "first",
            "second"
        ].forEach((tab)=>{
            Object.entries($b3698d22069af6cf$var$contentImages[tab]).forEach(([locale, imageSrc])=>{
                this.preloadImage(`content_${tab}_${locale}`, imageSrc);
                this.preloadImage(`tabbar_${tab}_${locale}`, $b3698d22069af6cf$var$tabBarImages[tab][locale]);
            });
        });
        // Apply content images
        Object.entries($b3698d22069af6cf$var$applyContentImages).forEach(([applyLang, localeImages])=>{
            Object.entries(localeImages).forEach(([locale, imageSrc])=>{
                this.preloadImage(`apply_content_${applyLang}_${locale}`, imageSrc);
            });
        });
        // Phase 3 specific FAQ images
        [
            "closed",
            "expanded"
        ].forEach((state)=>{
            // Second tab FAQ
            Object.entries($b3698d22069af6cf$var$faqImages[state].secondTab).forEach(([locale, src])=>{
                this.preloadImage(`faq_${state}_secondTab_${locale}`, src);
            });
            // Apply FAQ for Korean and Chinese
            [
                "ko",
                "cn"
            ].forEach((applyLang)=>{
                Object.entries($b3698d22069af6cf$var$faqImages[state].apply[applyLang]).forEach(([locale, src])=>{
                    this.preloadImage(`faq_${state}_apply_${applyLang}_${locale}`, src);
                });
            });
        });
    }
    preloadImage(key, src) {
        const img = new Image();
        img.src = src;
        this.preloadedImages.set(key, img);
    }
    setupLanguageDropdown() {
        const dropdown = document.getElementById("language-dropdown");
        const selectedLang = document.getElementById("selected-lang");
        const select = document.getElementById("localeSelect");
        // Set initial language text
        const languageMap = {
            en: "English",
            ja: "\u65E5\u672C\u8A9E",
            ko: "\uD55C\uAD6D\uC5B4",
            "zh-CN": "\u7B80\u4F53\u4E2D\u6587",
            "zh-TW": "\u7E41\u9AD4\u4E2D\u6587"
        };
        // Update selected language highlight
        const updateSelectedStyle = (currentLang)=>{
            // Remove highlight from all options
            document.querySelectorAll(".dropdown-option").forEach((option)=>{
                if (option.dataset.lang === currentLang) {
                    option.style.color = "rgba(255, 255, 255, 1)";
                    option.style.fontWeight = "700";
                } else {
                    option.style.color = "rgba(255, 255, 255, 0.4)";
                    option.style.fontWeight = "500";
                }
            });
        };
        // Initial setup
        const setSelectedText = ()=>{
            const currentLang = select.value;
            selectedLang.textContent = languageMap[currentLang];
            document.body.className = `lang-${currentLang}`;
            updateSelectedStyle(currentLang); // Add this line
        };
        setSelectedText();
        // Handle dropdown clicks
        dropdown.addEventListener("click", (e)=>{
            if (e.target.classList.contains("dropdown-option")) {
                const lang = e.target.dataset.lang;
                // Update the hidden select
                select.value = lang;
                setSelectedText();
                dropdown.classList.remove("active");
                // Trigger change event on select
                select.dispatchEvent(new Event("change"));
            } else dropdown.classList.toggle("active");
        });
        // Close dropdown when clicking outside
        document.addEventListener("click", (e)=>{
            if (!dropdown.contains(e.target)) dropdown.classList.remove("active");
        });
    }
    preloadVideos() {
        if ($b3698d22069af6cf$var$CURRENT_PHASE === "CLOSED") {
            // For CLOSED phase, only set up the youtube containers in closedContent
            const closedYoutubeContainer = document.querySelector("#closedContent .youtube-container");
            if (closedYoutubeContainer) this.setupVideoContainer(closedYoutubeContainer, "first");
            return; // Exit early since we don't need to set up other containers
        }
        [
            "youtube-container",
            "youtube-container2"
        ].forEach((containerId)=>{
            const container = document.querySelector(`.${containerId}`);
            if (!container) return;
            const videoType = containerId === "youtube-container" ? "first" : "second";
            this.setupVideoContainer(container, videoType);
        });
    }
    setupVideoContainer(container, videoType) {
        const wrapper = document.createElement("div");
        wrapper.style.position = "relative";
        wrapper.style.width = "100%";
        wrapper.style.height = "100%";
        container.appendChild(wrapper);
        [
            "chinese",
            "default"
        ].forEach((type)=>{
            const iframe = document.createElement("iframe");
            iframe.width = "100%";
            iframe.height = "100%";
            iframe.src = $b3698d22069af6cf$var$videoConfig[type][videoType];
            iframe.frameBorder = "0";
            iframe.allowFullscreen = true;
            iframe.style.position = "absolute";
            iframe.style.top = "0";
            iframe.style.left = "0";
            iframe.style.transition = "opacity 0.3s ease";
            iframe.style.opacity = "0";
            iframe.style.display = "none";
            wrapper.appendChild(iframe);
            if (!this.preloadedVideos[videoType]) this.preloadedVideos[videoType] = {};
            this.preloadedVideos[videoType][type] = iframe;
        });
    }
    updateVideoSource(locale) {
        const isChineseLang = [
            "zh-CN",
            "zh-TW"
        ].includes(locale);
        const activeType = isChineseLang ? "chinese" : "default";
        const inactiveType = isChineseLang ? "default" : "chinese";
        [
            "first",
            "second"
        ].forEach((videoType)=>{
            if (this.preloadedVideos[videoType]?.[activeType]) {
                this.preloadedVideos[videoType][activeType].style.display = "block";
                this.preloadedVideos[videoType][activeType].style.opacity = "1";
                this.preloadedVideos[videoType][inactiveType].style.opacity = "0";
                this.preloadedVideos[videoType][inactiveType].style.display = "none";
            }
        });
    }
    updateTabBarImage(tab = "first") {
        const locale = this.urlManager.getParam("locale") || "en";
        const tabBarImage = document.getElementById("tabImage");
        const imageSrc = $b3698d22069af6cf$var$tabBarImages[tab]?.[locale];
        if (imageSrc) {
            tabBarImage.src = imageSrc;
            // Add aria-label for accessibility
            tabBarImage.setAttribute("aria-label", `Switch to ${tab === "first" ? "second" : "first"} tab`);
        } else console.error(`No tab bar image found for tab: ${tab}, locale: ${locale}`);
    }
    updateApplyImage(applyLang, locale) {
        const applyImage = document.getElementById("applyImage");
        if (applyLang && locale) {
            const imageSrc = $b3698d22069af6cf$var$applyContentImages[applyLang][locale];
            if (imageSrc && applyImage) applyImage.src = imageSrc;
            else console.error(`No apply content image found for applyLang: ${applyLang}, locale: ${locale}`);
        } else if (!applyLang && locale) {
            // No applyLang provided, use the default content image
            const imageSrc = $b3698d22069af6cf$var$contentImages["first"][locale];
            if (imageSrc && applyImage) applyImage.src = imageSrc;
            else console.error(`No content image found for locale: ${locale}`);
        } else console.error("updateApplyImage: applyLang and locale parameters are required.");
    }
    updateExternalLinks(applyLang) {
        const links = $b3698d22069af6cf$var$externalLinksConfig[applyLang];
        if (!links) {
            console.error(`No links found for applyLang: ${applyLang}`);
            return;
        }
        const buttons = document.querySelectorAll("#applyContent .action-button");
        if (buttons.length >= 4) {
            buttons[0].onclick = ()=>window.open(links.link1); // Korean form
            buttons[1].onclick = ()=>window.open(links.link2); // English form
            buttons[2].onclick = ()=>window.open(links.link3); // Japanese form
            buttons[3].onclick = ()=>window.open(links.link4); // Chinese form
        }
    }
    updatePositions(locale) {
        this.updateFirstTabPositions(locale);
        this.updateSecondTabPositions(locale);
        this.updateApplyPositions(locale);
    }
    updateFirstTabPositions(locale) {
        const youtubeContainer = document.querySelector(".youtube-container");
        const youtubeContainer2 = document.querySelector(".youtube-container2");
        const youtubeStyle = $b3698d22069af6cf$var$styleConfig[$b3698d22069af6cf$var$CURRENT_PHASE].firstTab.youtube[locale];
        if (youtubeContainer && youtubeStyle) {
            Object.assign(youtubeContainer.style, youtubeStyle);
            youtubeContainer.style.background = "#ff000033"; // Debug
        }
        if ($b3698d22069af6cf$var$CURRENT_PHASE === "PHASE_3" && youtubeContainer2) {
            const youtube2Style = $b3698d22069af6cf$var$styleConfig[$b3698d22069af6cf$var$CURRENT_PHASE].firstTab.youtube2[locale];
            if (youtube2Style) {
                Object.assign(youtubeContainer2.style, youtube2Style);
                youtubeContainer2.style.background = "#0000ff33"; // Debug
                youtubeContainer2.style.position = "absolute"; // Add this
                youtubeContainer2.style.transform = "translateX(-50%)"; // Add this
            }
        }
        const nextButton = document.querySelector("#firstTabContent .action-button");
        const nextButtonStyle = $b3698d22069af6cf$var$styleConfig[$b3698d22069af6cf$var$CURRENT_PHASE].firstTab.nextButton[locale];
        if (nextButton && nextButtonStyle) Object.assign(nextButton.style, nextButtonStyle);
    }
    updateSecondTabPositions(locale) {
        const buttons = document.querySelectorAll("#secondTabContent .action-button");
        const styles = $b3698d22069af6cf$var$styleConfig[$b3698d22069af6cf$var$CURRENT_PHASE].secondTab.applyButtons[locale];
        if (buttons.length >= 2 && styles) {
            Object.assign(buttons[0].style, styles.korean);
            Object.assign(buttons[1].style, styles.chinese);
        }
    }
    updateFaqImage(locale, context = "secondTab") {
        const element = document.getElementById(`${context}Faq`);
        if (!element) return;
        const applyLang = this.urlManager.getParam("applyLang") || "ko";
        const currentFaqImages = $b3698d22069af6cf$var$PHASE_IMAGES[$b3698d22069af6cf$var$CURRENT_PHASE].faqImages;
        let imageSrc;
        const state = this.faqStates[context] ? "expanded" : "closed";
        imageSrc = context === "apply" ? currentFaqImages[state].apply[applyLang][locale] : currentFaqImages[state].secondTab[locale];
        if (imageSrc) {
            element.src = imageSrc;
            element.style.cursor = "pointer";
        }
    }
    updateApplyPositions(locale) {
        const buttons = document.querySelectorAll("#applyContent .action-button");
        const styles = $b3698d22069af6cf$var$styleConfig[$b3698d22069af6cf$var$CURRENT_PHASE].apply.links[locale];
        if (buttons.length >= 4 && styles) {
            Object.assign(buttons[0].style, styles.link1);
            Object.assign(buttons[1].style, styles.link2);
            Object.assign(buttons[2].style, styles.link3);
            Object.assign(buttons[3].style, styles.link4);
        }
    }
    initializeContent() {
        document.getElementById("mnetPlusLogo").src = (0, (/*@__PURE__*/$parcel$interopDefault($082908ab5b5b551a$exports)));
        const locale = this.urlManager.getParam("locale");
        const tab = this.urlManager.getParam("tab") || "first";
        const applyLang = this.urlManager.getParam("applyLang");
        if (applyLang && !this.previousState) this.previousState = {
            tab: "second",
            locale: locale
        };
        document.getElementById("localeSelect").value = locale;
        this.setupLanguageDropdown();
        if ($b3698d22069af6cf$var$CURRENT_PHASE === "CLOSED") {
            this.showContent(null, null);
            return;
        }
        this.updateTabBarImage(tab);
        this.showContent(tab, applyLang);
        this.updateContentImages(locale);
        this.updateApplyImage(applyLang, locale);
        this.updateBackButton(applyLang);
        this.updatePositions(locale);
        this.updateVideoSource(locale);
        // Initialize both FAQ images
        this.updateFaqImage(locale, "secondTab");
        this.updateFaqImage(locale, "apply");
    }
    setupEventListeners() {
        document.getElementById("localeSelect").addEventListener("change", (e)=>{
            const newLocale = e.target.value;
            this.urlManager.setParam("locale", newLocale);
            if ($b3698d22069af6cf$var$CURRENT_PHASE === "CLOSED") {
                // Update the closed image
                const closedImage = document.getElementById("closedImage");
                if (closedImage) closedImage.src = (0, $ac58a611ee7c1b70$export$8c49e528e4844b39)(newLocale);
                this.setupClosedYouTubeContainer(newLocale);
                return;
            }
            // Original logic for PHASE_3
            this.updateContentImages(newLocale);
            this.updateTabBarImage(this.urlManager.getParam("tab") || "first");
            this.updatePositions(newLocale);
            this.updateVideoSource(newLocale);
            // FAQ update logic
            const applyLang = this.urlManager.getParam("applyLang");
            if (applyLang) {
                this.updateFaqImage(newLocale, "apply");
                this.updateApplyImage(applyLang, newLocale);
            } else this.updateFaqImage(newLocale, "secondTab");
        });
        document.querySelector(".back-button").addEventListener("click", ()=>{
            this.handleBack();
        });
        // Add click handler for tab bar
        document.getElementById("tabImage").addEventListener("click", (e)=>{
            // Get current tab
            const currentTab = this.urlManager.getParam("tab") || "first";
            // Toggle between tabs
            const newTab = currentTab === "first" ? "second" : "first";
            // Only switch if we're not in apply mode
            if (!this.urlManager.getParam("applyLang")) {
                window.app.switchTab(newTab);
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }
        });
        // Second Tab FAQ click handler
        document.getElementById("secondTabFaq")?.addEventListener("click", ()=>{
            this.faqStates.secondTab = !this.faqStates.secondTab;
            const locale = this.urlManager.getParam("locale") || "en";
            this.updateFaqImage(locale, "secondTab");
            if (this.faqStates.secondTab) {
                const faqElement = document.getElementById("secondTabFaq");
                const offset = faqElement.offsetTop - 20; // Scroll to slightly above the FAQ
                setTimeout(()=>{
                    window.scrollTo({
                        top: offset,
                        behavior: "smooth"
                    });
                }, 100); // Small delay to ensure animation starts after FAQ expands
            }
        });
        // Apply FAQ click handler
        document.getElementById("applyFaq")?.addEventListener("click", ()=>{
            this.faqStates.apply = !this.faqStates.apply;
            const locale = this.urlManager.getParam("locale") || "en";
            this.updateFaqImage(locale, "apply");
            // Add scroll behavior when FAQ is expanded
            if (this.faqStates.apply) {
                const faqElement = document.getElementById("applyFaq");
                const offset = faqElement.offsetTop - 20; // Scroll to slightly above the FAQ
                setTimeout(()=>{
                    window.scrollTo({
                        top: offset,
                        behavior: "smooth"
                    });
                }, 100); // Small delay to ensure animation starts after FAQ expands
            }
        });
        // Update FAQ image when locale changes
        document.getElementById("localeSelect").addEventListener("change", (e)=>{
            const newLocale = e.target.value;
            this.urlManager.setParam("locale", newLocale);
            this.updateContentImages(newLocale);
            this.updateTabBarImage(this.urlManager.getParam("tab") || "first");
            this.updatePositions(newLocale);
            this.updateVideoSource(newLocale); // Add this line
            // FAQ update logic
            const applyLang = this.urlManager.getParam("applyLang");
            if (applyLang) {
                this.updateFaqImage(newLocale, "apply");
                this.updateApplyImage(applyLang, newLocale); // Update applyImage
            } else this.updateFaqImage(newLocale, "secondTab");
        });
    }
    updateContentImages(locale) {
        const firstTabImageSrc = $b3698d22069af6cf$var$contentImages.first[locale];
        const secondTabImageSrc = $b3698d22069af6cf$var$contentImages.second[locale];
        if (firstTabImageSrc) document.getElementById("firstTabImage").src = firstTabImageSrc;
        if (secondTabImageSrc) document.getElementById("secondTabImage").src = secondTabImageSrc;
    }
    showContent(tab, applyLang) {
        // Hide all content sections first
        document.getElementById("firstTabContent").style.display = "none";
        document.getElementById("secondTabContent").style.display = "none";
        document.getElementById("applyContent").style.display = "none";
        document.getElementById("closedContent").style.display = "none";
        // Reset FAQ states when switching content
        this.faqStates.secondTab = false;
        this.faqStates.apply = false;
        // Check if we're in CLOSED phase
        if ($b3698d22069af6cf$var$CURRENT_PHASE === "CLOSED") {
            // Hide back button
            document.querySelector(".back-button").style.display = "none";
            // Set Click event to Logo for closed phase
            const logo = document.querySelector(".company-logo");
            logo.addEventListener("click", this.handleLogoClick);
            // Hide tabs
            const tabsElement = document.querySelector(".tabs");
            if (tabsElement) tabsElement.style.display = "none";
            // Show closed content
            document.getElementById("closedContent").style.display = "block";
            // Set closed image based on locale
            const locale = this.urlManager.getParam("locale") || "en";
            const closedImage = document.getElementById("closedImage");
            if (closedImage) closedImage.src = (0, $ac58a611ee7c1b70$export$8c49e528e4844b39)(locale);
            // Set up YouTube container
            this.setupClosedYouTubeContainer(locale);
            return;
        }
        // Handle tab visibility
        const tabsElement = document.querySelector(".tabs");
        if (applyLang) {
            this.updateExternalLinks(applyLang);
            tabsElement.style.display = "none";
            document.getElementById("applyContent").style.display = "block";
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        } else {
            tabsElement.style.display = "block";
            document.getElementById(`${tab}TabContent`).style.display = "block";
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
        // Update FAQ images for both contexts
        const locale = this.urlManager.getParam("locale") || "en";
        this.updateFaqImage(locale, "secondTab");
        this.updateFaqImage(locale, "apply");
        this.updateApplyImage(applyLang, locale);
    }
    // Add a new method for setting up the closed YouTube container
    setupClosedYouTubeContainer(locale) {
        const youtubeContainer = document.querySelector("#closedContent .youtube-container");
        if (!youtubeContainer) return;
        // Clear any existing content first
        youtubeContainer.innerHTML = "";
        // Apply styling based on locale
        const youtubeStyle = $b3698d22069af6cf$var$styleConfig.CLOSED.youtube[locale] || $b3698d22069af6cf$var$styleConfig.CLOSED.youtube.en;
        if (youtubeStyle) {
            // Apply all styles from the config
            Object.assign(youtubeContainer.style, youtubeStyle);
            // Ensure these critical styles are always applied
            youtubeContainer.style.position = "absolute";
            youtubeContainer.style.transform = "translateX(-50%)";
            youtubeContainer.style.zIndex = "10";
            youtubeContainer.style.pointerEvents = "auto";
        }
        // Create a wrapper div like in setupVideoContainer
        const wrapper = document.createElement("div");
        wrapper.style.position = "relative";
        wrapper.style.width = "100%";
        wrapper.style.height = "100%";
        youtubeContainer.appendChild(wrapper);
        // Create iframes for both Chinese and default sources
        [
            "chinese",
            "default"
        ].forEach((type)=>{
            const iframe = document.createElement("iframe");
            iframe.width = "100%";
            iframe.height = "100%";
            iframe.src = $b3698d22069af6cf$var$videoConfig[type]["first"]; // Always use 'first' for closed phase
            iframe.frameBorder = "0";
            iframe.allowFullscreen = true;
            iframe.style.position = "absolute";
            iframe.style.top = "0";
            iframe.style.left = "0";
            iframe.style.transition = "opacity 0.3s ease";
            iframe.style.opacity = "0";
            iframe.style.display = "none";
            wrapper.appendChild(iframe);
            // Store reference to iframe for later use
            if (!this.preloadedVideos["first"]) this.preloadedVideos["first"] = {};
            this.preloadedVideos["first"][type] = iframe;
        });
        // Show the appropriate video based on locale
        const isChineseLang = [
            "zh-CN",
            "zh-TW"
        ].includes(locale);
        const activeType = isChineseLang ? "chinese" : "default";
        const inactiveType = isChineseLang ? "default" : "chinese";
        this.preloadedVideos["first"][activeType].style.display = "block";
        this.preloadedVideos["first"][activeType].style.opacity = "1";
    }
    updateBackButton(applyLang) {
        const logo = document.querySelector(".company-logo");
        const backButton = document.querySelector(".back-button");
        if (this.isMobileWebView()) {
            logo.style.display = "none";
            backButton.style.display = "inline-block";
            // Remove existing listeners
            backButton.replaceWith(backButton.cloneNode(true));
            const newBackButton = document.querySelector(".back-button");
            if (applyLang) // When on apply page
            newBackButton.addEventListener("click", ()=>this.handleBack());
            else // Only add close handler when not navigating back
            newBackButton.addEventListener("click", this.handleWebViewClose);
        } else // Regular web handling...
        if (applyLang) {
            logo.style.display = "none";
            backButton.style.display = "inline-block";
            backButton.addEventListener("click", ()=>this.handleBack());
        } else {
            logo.style.display = "inline-block";
            backButton.style.display = "none";
            logo.addEventListener("click", this.handleLogoClick);
        }
    }
    isMobileWebView() {
        return typeof window.MnetPlusApp !== "undefined" && window.MnetPlusApp.startsWith("Mnet Plus/");
    }
    handleWebViewClose = ()=>{
        window.ReactNativeWebView.postMessage('{"command":"close"}');
    };
    handleLogoClick = ()=>{
        window.open("https://mnetplus.world/main", "_blank");
    };
    storePreviousState() {
        this.previousState = {
            tab: this.urlManager.getParam("tab") || "first",
            locale: this.urlManager.getParam("locale")
        };
    }
    handleBack() {
        if (this.previousState) {
            // Show tabs when going back
            document.querySelector(".tabs").style.display = "block";
            this.urlManager.setParam("applyLang", null);
            this.urlManager.setParam("tab", this.previousState.tab);
            this.updateTabBarImage(this.previousState.tab);
            this.showContent(this.previousState.tab, null);
            // Just update UI without adding new event listeners yet
            const logo = document.querySelector(".company-logo");
            const backButton = document.querySelector(".back-button");
            if (this.isMobileWebView()) {
                logo.style.display = "none";
                backButton.style.display = "inline-block";
            } else {
                logo.style.display = "inline-block";
                backButton.style.display = "none";
            }
            this.previousState = null;
            // Now add the close handler after navigation is complete
            if (this.isMobileWebView()) setTimeout(()=>{
                backButton.replaceWith(backButton.cloneNode(true));
                const newBackButton = document.querySelector(".back-button");
                newBackButton.addEventListener("click", this.handleWebViewClose);
            }, 0);
        }
    }
}


var $ffbabd7aa621871a$exports = {};
$ffbabd7aa621871a$exports = JSON.parse('{"ko":"\uC9C0\uC6D0\uC774 \uB9C8\uAC10\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","en":"Applications are now closed.","zh-CN":"\u62A5\u540D\u5DF2\u622A\u6B62\u3002","zh-TW":"\u5831\u540D\u5DF2\u622A\u6B62\u3002","ja":"\u5FDC\u52DF\u304C\u7D42\u4E86\u3055\u308C\u307E\u3057\u305F\u3002"}');



function $f5e5effd96d66274$var$disablePinchZoom() {
    document.addEventListener("touchstart", function(e) {
        if (e.touches.length > 1) e.preventDefault();
    }, {
        passive: false
    });
    document.addEventListener("touchmove", function(e) {
        if (e.scale && e.scale !== 1) e.preventDefault();
    }, {
        passive: false
    });
}
$f5e5effd96d66274$var$disablePinchZoom();
const $f5e5effd96d66274$var$urlManager = new (0, $1325fc2d863ad7af$export$de90c65777477aa1)();
const $f5e5effd96d66274$var$contentManager = new (0, $b3698d22069af6cf$export$3c34ec388832a30)($f5e5effd96d66274$var$urlManager);
// Define the handler function in the global scope
function $f5e5effd96d66274$var$handleClickOnApplyButton() {
    window.app.switchTab("second");
}
function $f5e5effd96d66274$var$navToApply(applyLang) {
    if ((0, $1b4ea618ab3eb316$export$a6391b78f4f106fe)()) window.app.showApply(applyLang);
    else {
        const locale = $f5e5effd96d66274$var$urlManager.getParam("locale");
        alert((0, (/*@__PURE__*/$parcel$interopDefault($ffbabd7aa621871a$exports)))[locale]);
    }
}
function $f5e5effd96d66274$var$navToApplyK() {
    if ((0, $1b4ea618ab3eb316$export$8bde0eacd3f07e8b)()) window.app.showApply("ko");
    else {
        const locale = $f5e5effd96d66274$var$urlManager.getParam("locale");
        alert((0, (/*@__PURE__*/$parcel$interopDefault($ffbabd7aa621871a$exports)))[locale]);
    }
}
function $f5e5effd96d66274$var$navToApplyC() {
    if ((0, $1b4ea618ab3eb316$export$a6391b78f4f106fe)()) window.app.showApply("cn");
    else {
        const locale = $f5e5effd96d66274$var$urlManager.getParam("locale");
        alert((0, (/*@__PURE__*/$parcel$interopDefault($ffbabd7aa621871a$exports)))[locale]);
    }
}
// Make it available globally
window.handleClickOnApplyButton = $f5e5effd96d66274$var$handleClickOnApplyButton;
window.navToApplyK = $f5e5effd96d66274$var$navToApplyK;
window.navToApplyC = $f5e5effd96d66274$var$navToApplyC;
window.app = {
    switchTab: (tab)=>{
        $f5e5effd96d66274$var$urlManager.setParam("tab", tab);
        $f5e5effd96d66274$var$urlManager.setParam("applyLang", null);
        $f5e5effd96d66274$var$contentManager.updateTabBarImage(tab); // Updated method name
        $f5e5effd96d66274$var$contentManager.showContent(tab, null);
    },
    showApply: (lang)=>{
        $f5e5effd96d66274$var$contentManager.storePreviousState();
        $f5e5effd96d66274$var$urlManager.setParam("applyLang", lang);
        $f5e5effd96d66274$var$contentManager.showContent(null, lang);
        $f5e5effd96d66274$var$contentManager.updateBackButton(lang);
    }
};


//# sourceMappingURL=index.2d28ea15.js.map
